import React from 'react'
import {
    Text,
    Button,
    Flex,
    useColorMode
} from '@chakra-ui/react'
import Card from "components/Card/Card";

import axios from 'axios'

import apiUrl from "variables/api";
import { toast } from 'react-toastify';

function Page() {
    const { colorMode } = useColorMode();

    const [data, setData] = React.useState({})

    React.useEffect(() => {
        axios.get(apiUrl + '/data/changes-sum', {headers: {'x-access-token': localStorage.getItem('token')}}).then(res => {
            setData(res.data)
            console.log(res.data)
        })

    }, [])

    return (
        <Flex pt={{ base: "120px", md: "75px" }} direction={'column'} gap={5}>
        <Card>
            <Flex justifyContent={"center"} alignItems={"center"} direction={"column"}>
                <Text as='b' fontSize='2xl'>Podgląd raportów zmianowych</Text>
                <Text fontWeight={"bold"} fontSize='xl'>Dane za okres (#{data.period}) {data.periodDate}</Text>
                {data?.dataOne?.length !== 0 && data?.dataTwo?.length !== 0 && (
                    <Button
                        colorScheme="red"
                        mt={5}
                        onClick={() => {
                            axios.post(apiUrl + '/data/changes-send', "senddata" , { headers: { 'x-access-token': localStorage.getItem('token') } })
                                .then(response => {
                                    toast.success('Pomyślnie wysłano raport!');
                                    console.log('Data sent successfully:', response.data);
                                })
                                .catch(error => {
                                    console.error('There was an error sending the data!', error);
                                });
                        }}
                    >
                        Wyślij
                    </Button>
                )}
            </Flex>
        </Card>
        <Flex direction={'row'} gap={5}>
            <Card>
                <Text as='b' fontSize={'xl'}>Zmiana I</Text>
                <Flex direction={'column'} gap={2}>
                    <Text>Liczba osób na zmianie: {data.dataOne?.peoplesOnChange}</Text>
                    <Text>Liczba osób na aktywnej słubie: {data?.dataOne?.peoplesOnActiveDuty}</Text>
                    <Text>Liczba osób na zawieszeniu: {data?.dataOne?.peoplesOnSuspension}</Text>
                    <Text>Liczba osób na urlopie: {data?.dataOne?.peoplesOnVacation}</Text>
                    <Text>Liczba osób, które przeszły ze zmiany I na zmianę II: {data?.dataOne?.transferFromOneToTwo}</Text>
                    <Text>Liczba osób, które przeszły ze zmiany II na zmianę I: {data?.dataOne?.transferFromTwoToOne}</Text>
                    <Text>Liczba osób, które dołączyły po ukończonym kursie podstawowym: {data?.dataOne?.peoplesAfterCourse}</Text>
                    <Text>Liczba osób, które powróciły do frakcji: {data?.dataOne?.peoplesComeback}</Text>
                    <Text>Liczba osób, które opuściły frakcje: {data?.dataOne?.peoplesQuit}</Text>
                    <Text>Ilość zmian nicków: {data?.dataOne?.nicknameChange}</Text>
                    <Text>Ilość skarg na pracowników: {data?.dataOne?.complaints}</Text>
                    <Text>Ilość pochwał na pracowników: {data?.dataOne?.praise}</Text>
                    <Text>Dowódca Zmiany I: {data?.dataOne?.commanderI}</Text>
                    <Text>Zastępca Dowódcy Zmiany I: {data?.dataOne?.sideCommanderI}</Text>
                </Flex>
            </Card>
            <Card>
                <Text as='b' fontSize={'xl'}>Zmiana II</Text>
                <Flex direction={'column'} gap={2}>
                    <Text>Liczba osób na zmianie: {data.dataTwo?.peoplesOnChange}</Text>
                    <Text>Liczba osób na aktywnej słubie: {data?.dataTwo?.peoplesOnActiveDuty}</Text>
                    <Text>Liczba osób na zawieszeniu: {data?.dataTwo?.peoplesOnSuspension}</Text>
                    <Text>Liczba osób na urlopie: {data?.dataTwo?.peoplesOnVacation}</Text>
                    <Text>Liczba osób, które przeszły ze zmiany I na zmianę II: {data?.dataTwo?.transferFromOneToTwo}</Text>
                    <Text>Liczba osób, które przeszły ze zmiany II na zmianę I: {data?.dataTwo?.transferFromTwoToOne}</Text>
                    <Text>Liczba osób, które dołączyły po ukończonym kursie podstawowym: {data?.dataTwo?.peoplesAfterCourse}</Text>
                    <Text>Liczba osób, które powróciły do frakcji: {data?.dataTwo?.peoplesComeback}</Text>
                    <Text>Liczba osób, które opuściły frakcje: {data?.dataTwo?.peoplesQuit}</Text>
                    <Text>Ilość zmian nicków: {data?.dataTwo?.nicknameChange}</Text>
                    <Text>Ilość skarg na pracowników: {data?.dataTwo?.complaints}</Text>
                    <Text>Ilość pochwał na pracowników: {data?.dataTwo?.praise}</Text>
                    <Text>Dowódca Zmiany II: {data?.dataTwo?.commanderII}</Text>
                    <Text>Zastępca Dowódcy Zmiany II: {data?.dataTwo?.sideCommanderII}</Text>
                </Flex>
            </Card>
        </Flex>
        </Flex>
    );
}

export default Page